/*
 * @Description: 有关视图字段显示及筛选字段的处理
 * @Version: 2.0
 * @Autor: 胡彩丽 hucaili@qfei.cn
 * @LastEditors: 胡彩丽 hucaili@qfei.cn
 */
import { reactive, toRefs } from 'vue';
import { publicService, layoutService, poolClueService, formulaFieldService } from '@/api/';
import { Message } from '@arco-design/web-vue';
import dayjs from 'dayjs';
import { checkboxFieldList, huaYingOrdId, checkboxOptions, inputFieldList } from '@/utils/const';
import { useUserStore } from '@/store';
import { tools } from '@/utils/tools.js';
import i18n from '@/locales/index';
import { aiPointsCopyClearFieldKeys, confine, associationEmptyText } from '@/utils/const';
// const { userInfo } = useUserStore();
export default function useViewFields() {
  const { userInfo } = useUserStore();
  const data = reactive({
    type: 0, //对象id
    list: [], //其他对象的列表数据
    fieldTypeList: [2, 3, 4, 5], //单选，多选，下拉单选，多选
    enableList: [], //新增可展示的所有字段
    associationDefaultFields: [], //查找关联默认展示字段
    associationDefaultFieldsAll: [], //查找关联所有展示字段
    fieldListShow: [], //列表可展示的字段
    searchList: [], //筛选所有的字段值
    filterSearchList: {
      //高级筛选所有的字段值
      searchSelect: [], //搜索输入框的值
      filterSelect: [], //其他筛选条件值
      leadPoolSelect: [] // 线索池搜索框
    },
    filterSearchParams: [], //处理搜索时的参数
    fieldsListAll: [], //布局所有字段数据
    layoutFieldList: [], //列表布局字段
    layoutAddModules: [], //新增/编辑页面布局字段
    layoutDetailModules: [], //编辑页面布局字段
    layoutDetailAllList: [], //详情页面总数据---包含详情权限
    layoutDetailConfig: null, //详情页面布局配置
    layoutMainField: {}, //对象主属性字段
    logicRolePermission: null, //详情权限
    layoutDetailLoading: true,
    departmentList: [], //部门信息
    fieldsJokerList: {}, //0-不显示 1-显示 2-满足条件显示 //0-非必填 1-必填 2-满足条件必填
    referenceFieldValue: [], //引用字段
    sendFormData: {}, //新增/编辑上传的数据
    layoutAllFields: {}, //布局详情中使用的所有字段
    conversionLayoutList: [], //线索转化客户数据列表
    conversionData: {
      allFieldsObj: {}, //所有字段对象
      tableList: [] //表格列表
    }, //线索转化客户提交时字段处理
    splitType: null // 分裂模式 2 未分裂、 3 分裂
  });
  // 获取小数点后个数
  const decimalPlaces = (str) => {
    const match = String(str).match(/\d+$/);
    return match ? match[0].length : 0;
  };
  // 除以100后保留小数点后几位
  const divideAndRound = (num) => {
    return (num / 100).toFixed(Number(decimalPlaces(num) + 2));
  };

  // 获取查找关联字段弹窗显示字段
  const getAssociationFields = async (params) => {
    if (params) {
      try {
        const json = await publicService.getSysEntityFormFields(params);
        const res = json.result || [];
        if (res?.length) {
          data.associationDefaultFields = res?.filter((i) => i.isEnabled === true);
          data.associationDefaultFieldsAll = res;
        }
        return data;
      } catch (e) {
        console.log(265, e);
        return [];
      }
    } else {
      return [];
    }
  };

  // 获取视图字段列表数据
  const getViewFields = async (params) => {
    data.list = [];
    data.enableList = [];
    data.searchList = [];
    data.fieldListShow = [];
    if (params) {
      try {
        const json = await publicService.getField(params);
        const res = json.result || [];
        data.type = params.id;
        if (res?.records?.length) {
          data.list = JSON.parse(JSON.stringify(res?.records));
          const updateList = data.list?.map((item) => {
            if (item.fieldExt && [2, 3, 4, 5, 10].indexOf(item.fieldType) > -1) {
              item.fieldExt = JSON.stringify(JSON.parse(item.fieldExt)?.filter((i) => i.isEnabled));
            }
            return item;
          });
          //列表要显示的字段
          const sortListShow = updateList?.filter((i) => i.listShow === true)?.sort((a, b) => (b?.sort !== '' && b?.sort !== null) - (a?.sort !== '' && a?.sort !== null) || a?.sort - b?.sort);
          data.fieldListShow = sortListShow?.filter((i) => i.fieldType != 18); //列表需要显示的字段，把附件过滤掉
          //已启用的字段
          data.enableList = updateList?.filter((i) => i.isEnabled === true)?.sort((a, b) => (b?.sort !== '' && b?.sort !== null) - (a?.sort !== '' && a?.sort !== null) || a?.sort - b?.sort);
          //搜索要使用的字段
          data.searchList = JSON.parse(JSON.stringify(data.fieldListShow));
        }
        return data;
      } catch (e) {
        console.log(265, e);
        return [];
      }
    } else {
      return [];
    }
  };
  // 获取布局列表字段数据
  const getLayoutFieldsObject = async (params) => {
    data.layoutFieldList = [];
    data.fieldsListAll = [];
    if (params) {
      try {
        const json = await layoutService.getLayoutField(params);
        data.type = params.entity;
        data.fieldsListAll = JSON.parse(JSON.stringify(json.result));
        if (data.fieldsListAll?.fields?.length > 0) {
          const updateList = data.fieldsListAll?.fields?.map((item) => {
            if (item?.fieldExt && [2, 3, 4, 5, 10].indexOf(item.fieldType) > -1) {
              const getFieldExt = tools.isJSON(item?.fieldExt) ? JSON.parse(item.fieldExt)?.filter((i) => i.isEnabled) : item?.fieldExt;
              item.fieldExt = JSON.stringify(getFieldExt);
            }
            return item;
          });
          //列表要显示的字段
          data.layoutFieldList = json.result?.fields || []; //列表需要显示的字段，
          data.enableList = updateList;
        }
        return data;
      } catch (e) {
        console.log(265, e);
        return [];
      }
    } else {
      return [];
    }
  };

  //表单校验规则
  const rules = (basic) => {
    if (basic.isRequired == 1 || (basic.conditionsIsRequired && basic.conditionsIsRequired == 1)) {
      // 0-非必填 1-必填 2-满足条件必填
      if (basic.value === 'mobile') {
        //手机号(华映对手机号不做必填教研)
        return [
          {
            required: basic.isRequired,
            message: `${i18n.global.t('tips.phoneNumber')}`
          }
        ];
      } else {
        if (basic?.setting?.fieldType === 0 || basic?.setting?.fieldType === 1 || basic?.setting?.fieldType === 7 || basic?.setting?.fieldType === 11) {
          if (basic?.setting?.fieldType === 7) {
            return {
              required: basic.isRequired,
              message: `${basic.label}${i18n.global.t('是必填项')}`
            };
          }
          return {
            required: basic.isRequired,
            validator: (value, cb) => {
              if (value) {
                // 多行文本
                if (basic?.setting?.fieldType === 1) {
                  if (value?.length >= confine.number10001) {
                    cb(`录入字符数已达上限${confine.number10000}位，请检查`);
                  }
                } else {
                  if (value?.length >= confine.number5001) {
                    cb(`录入字符数已达上限${confine.number5000}位，请检查`);
                  }
                  if (basic?.setting?.fieldType === 11 && !tools.checkLink(value)) {
                    cb('格式不正确,请以http:// 或 https:// 开头,且不能包含汉字');
                  }
                }
              } else {
                cb(`${basic.label}${i18n.global.t('是必填项')}`);
              }
            }
          };
        } else {
          return {
            required: basic.isRequired,
            message: `${basic.label}${i18n.global.t('是必选项')}`
          };
        }
      }
    } else {
      return {
        required: false,
        validator: (value, cb) => {
          if (value) {
            // 多行文本
            if (basic?.setting?.fieldType === 1) {
              if (value?.length >= confine.number10001) {
                cb(`录入字符数已达上限${confine.number10000}位，请检查`);
              }
            } else {
              if (basic?.setting?.fieldType === 0 || basic?.setting?.fieldType === 7 || basic?.setting?.fieldType === 11) {
                if (value?.length >= confine.number5001) {
                  cb(`录入字符数已达上限${confine.number5000}位，请检查`);
                }
                if (basic?.setting?.fieldType === 11 && !tools.checkLink(value)) {
                  cb('格式不正确,请以http:// 或 https:// 开头,且不能包含汉字');
                }
              }
            }
          }
        }
      };
    }
  };
  //初始化处理新增数据(处理默认值)
  const setAddForm = (item) => {
    if (item.setting?.fieldExt && [2, 3, 4, 5, 10].indexOf(item.setting.fieldType) > -1) {
      item.setting.fieldExt = JSON.stringify(
        JSON.parse(item.setting?.fieldExt)
          ?.filter((i) => i.isEnabled !== false)
          ?.sort((a, b) => (b?.sort !== '' && b?.sort !== null) - (a?.sort !== '' && a?.sort !== null) || a?.sort - b?.sort)
      );
    }
    if (item.setting?.fieldType == 21 && item?.setting?.business && [2, 3, 4, 5, 10].indexOf(item?.setting?.business?.fieldType) > -1) {
      item.setting.business.fieldExt = JSON.stringify(
        JSON.parse(item.setting.business.fieldExt)
          ?.filter((i) => i.isEnabled !== false)
          ?.sort((a, b) => (b?.sort !== '' && b?.sort !== null) - (a?.sort !== '' && a?.sort !== null) || a?.sort - b?.sort)
      );
    }
    if (item.setting?.fieldType === 3 || item.setting?.fieldType === 5) {
      item.defaultValue = item?.defaultValue ? item.defaultValue?.split(',') : [];
    } else if (item.setting?.fieldType === 6) {
      //人员
      if (item.isExistDefValue == 2) {
        // 选择当前人员
        item.setting.fv = {
          departList: [],
          userList: [
            {
              userName: userInfo.userName,
              id: userInfo.id,
              avatarOrigin: userInfo?.avatarOrigin
            }
          ]
        };
        item.defaultValue = [userInfo.userName];
      } else {
        //  single 0 是多选
        if (tools.isJSON(item.setting?.fieldExt) && JSON.parse(item.setting?.fieldExt)?.single == 1 && item.defaultValue?.userIds?.length > 1) {
          item.defaultValue = '';
          item.setting.fv = { departList: [], userList: [] };
        } else {
          const setDefVal = item.defaultValue
            ? item.defaultValue?.userIds?.map((u) => {
                return u.name;
              })
            : [];
          item.setting.fv =
            item.defaultValue && item.defaultValue?.userIds
              ? {
                  departList: [],
                  // userList: [{ userName: item?.defaultValue?.userIds[0]?.name, id: item?.defaultValue?.userIds[0]?.id, avatarOrigin: item?.defaultValue?.userIds[0]?.avatar }]
                  userList: item?.defaultValue?.userIds?.map((u) => {
                    return {
                      userName: u.name,
                      id: u.id,
                      avatarOrigin: u.avatar
                    };
                  })
                }
              : '';
          item.defaultValue = setDefVal;
        }
      }
    } else if (item.setting?.fieldType === 7) {
      //数字
      item.defaultValue = !isNaN(parseFloat(item.defaultValue)) ? Number(parseFloat(item.defaultValue)) : '';
    } else if (item.setting?.fieldType === 8) {
      //  isExistDefValue   2 展示当前时间
      if (item.isExistDefValue == 2) {
        item.defaultValue = dayjs().format('YYYY-MM-DD HH:mm:ss');
      } else {
        item.defaultValue = item.defaultValue != null && item.defaultValue != undefined ? item.defaultValue : '';
      }
    } else if (item.setting?.fieldType === 9) {
      //日期范围
      const hasRangeValue = tools.isJSON(item?.defaultValue) && JSON.parse(item?.defaultValue)?.beginDate && JSON.parse(item?.defaultValue)?.endDate;
      if (hasRangeValue) {
        item.defaultValue = Object.values(JSON.parse(item?.defaultValue));
      } else {
        item.defaultValue = '';
      }
    } else if (item.setting?.fieldType === 10) {
      //级联选择
      item.defaultValue = item.defaultValue ? item.defaultValue?.split('/') : '';
    } else if (item.setting?.fieldType == 16) {
      //金额
      if (item.setting?.fieldExt) {
        item.defaultValue = !isNaN(parseFloat(item.defaultValue)) ? tools.getPrice(Number(item.defaultValue, item?.setting.fieldExt)) : '';
      } else {
        item.defaultValue = !isNaN(parseFloat(item.defaultValue)) ? tools.getPrice(item.defaultValue, 2) : '';
      }
    } else if (item.setting?.fieldType === 18) {
      //附件

      let newFieldValue = [];

      // 检查默认值存在且为有效JSON格式
      if (item.defaultValue && tools.isJSON(item.defaultValue)) {
        const parsedValue = JSON.parse(item.defaultValue);
        const validAttachments = Array.isArray(parsedValue) ? parsedValue.filter((item) => item != null) : [];

        // 为每个有效项添加default标记
        newFieldValue = validAttachments.map((attach) => ({
          ...attach,
          default: true
        }));
      }

      item.defaultValue = newFieldValue;

      if (!item.setting.fieldExt) {
        //没有fieldExt时
        item.setting.fieldExt = JSON.stringify({ limit: 10, accept: [0] });
      }
    } else if (item.setting?.fieldType == 23) {
      //百分比
      if (tools.isJSON(item.setting?.fieldExt)) {
        item.defaultValue = item.defaultValue ? tools.getPercentage(item.defaultValue, JSON.parse(item.setting?.fieldExt)?.numberFormat) : '';
      } else {
        item.defaultValue = item.defaultValue ? tools.getPercentage(item.defaultValue, 2) : '';
      }
    } else if (item.setting?.fieldType === 22) {
      //部门
      if (item.isExistDefValue == 2) {
        // 选择当前部门
        item.setting.fv = {
          departList:
            userInfo.departmentName && userInfo.departmentIds && userInfo.departmentIds[0]
              ? [
                  {
                    departmentName: userInfo.departmentName,
                    id: userInfo.departmentIds && userInfo.departmentIds[0]
                  }
                ]
              : [],
          userList: []
        };
        item.defaultValue = userInfo.departmentName && userInfo.departmentIds && userInfo.departmentIds[0] ? [userInfo.departmentName] : [];
      } else {
        // 新增需求 本次是单选 上一次是多选(大于2) 时  清空数据
        if (item.setting.fieldExt == 1 && item.defaultValue?.departIds?.length > 1) {
          item.defaultValue = '';
          item.setting.fv = { departList: [], userList: [] };
        } else {
          const setDefVal = item.defaultValue
            ? item.defaultValue?.departIds?.map((departItem) => {
                return departItem.name;
              })
            : '';
          item.setting.fv =
            item.defaultValue && item.defaultValue?.departIds
              ? {
                  departList: item.defaultValue?.departIds?.map((u) => {
                    return {
                      departmentName: u.name,
                      id: u.id
                    };
                  }),
                  userList: []
                }
              : '';
          item.defaultValue = setDefVal;
        }
      }
    } else {
      item.defaultValue = item.defaultValue != null && item.defaultValue != undefined ? item.defaultValue : '';
    }
    return item;
  };
  //初始化处理编辑数据
  const setEditForm = (item, options = {}) => {
    //编辑处理fieldValue
    const fieldType = item.setting?.fieldType == 21 && item?.setting?.business ? item?.setting?.business?.fieldType : item.setting?.fieldType;
    const getFieldExt = item.setting?.fieldType == 21 && item?.setting?.business ? item?.setting?.business?.fieldExt : item.setting?.fieldExt;
    if (getFieldExt && [2, 3, 4, 5].indexOf(fieldType) > -1) {
      //把已经禁用的选项过滤掉
      if (item.setting?.fieldType == 21 && item?.setting?.business) {
        // item.setting.business.fieldExt = JSON.stringify(JSON.parse(getFieldExt)?.filter((i) => i.isEnabled));
        item.setting.business.fieldExt = JSON.stringify(
          JSON.parse(getFieldExt)
            ?.filter((i) => i.isEnabled !== false)
            ?.sort((a, b) => (b?.sort !== '' && b?.sort !== null) - (a?.sort !== '' && a?.sort !== null) || a?.sort - b?.sort)
        );
      } else {
        // item.setting.fieldExt = JSON.stringify(JSON.parse(getFieldExt)?.filter((i) => i.isEnabled));
        item.setting.fieldExt = JSON.stringify(
          JSON.parse(getFieldExt)
            ?.filter((i) => i.isEnabled !== false)
            ?.sort((a, b) => (b?.sort !== '' && b?.sort !== null) - (a?.sort !== '' && a?.sort !== null) || a?.sort - b?.sort)
        );
      }
    }
    const fieldExt = item.setting?.fieldType == 21 && item?.setting?.business ? item?.setting?.business?.fieldExt : item.setting?.fieldExt;
    if (item.setting?.fieldType != 21) {
      // 单选 下拉单选
      if (fieldType === 2 || fieldType === 4) {
        const getFieldValue = item.fieldValue ?? '';
        const getFieldExt = fieldExt && tools.isJSON(fieldExt) ? JSON.parse(fieldExt) : [];
        const findOption = getFieldExt?.find((el) => el.value == getFieldValue);
        if (!findOption) {
          //在fieldExt里没有获取到把值清空
          item.fieldValue = '';
        }
        // 选择线索池需要类型转换
        if (fieldType === 4 && item.setting.fieldKey == 'cluePoolId' && item?.fieldValue) {
          item.fieldValue = String(item.fieldValue);
        }
      }
      //多选按钮，下拉多选
      if (fieldType === 3 || fieldType === 5) {
        const getFieldValue = item.fieldValue && typeof item.fieldValue === 'string' ? item.fieldValue?.split(',') : [];
        const getFieldExt = fieldExt && tools.isJSON(fieldExt) ? JSON.parse(fieldExt) : [];
        const valuesInAa = new Set(getFieldExt?.map((item) => item.value)); //把value过滤出来
        const filteredBb = getFieldValue?.filter((value) => valuesInAa.has(value));
        //2025年05月12日16:16:29多选和下拉多选默认值为空数组 并非空字符串
        item.fieldValue = filteredBb && filteredBb?.length > 0 ? filteredBb : []; //把在fieldExt里不存在的选项值清空
      } else if (fieldType === 6) {
        //人员
        item.setting.fv = {
          departList: [],
          userList: item.fieldValue && Array.isArray(item.fieldValue) ? item.fieldValue.map((e) => ({ userName: e?.userName, id: e?.userId, avatarOrigin: e?.avatar })) : []
        };
        item.fieldValue = item.fieldValue && Array.isArray(item.fieldValue) ? item.fieldValue.map((e) => e?.userName) : [];
      } else if (fieldType === 7) {
        //数字
        item.fieldValue = item.fieldValue == null ? item.fieldValue : Number(parseFloat(item.fieldValue).toFixed(tools.isJSON(fieldExt) ? JSON.parse(fieldExt)?.numberFormat : 2));
      }
      // else if (item.setting?.fieldType === 8) {
      //   //日期类型
      //   const ext = item.setting?.fieldExt === 'YYYY/M/DD' ? 'YYYY/MM/DD' : item.setting?.fieldExt === 'YYYY-M-DD' ? 'YYYY-MM-DD' : item.setting?.fieldExt;
      //   item.fieldValue = item?.fieldValue && item.setting?.fieldExt ? dayjs(item.fieldValue).format(ext) : '';
      // }
      else if (fieldType === 9) {
        //日期范围
        item.fieldValue = item.fieldValue ? Object.values(JSON.parse(item.fieldValue)) : [];
      } else if (fieldType === 10) {
        //级联选择
        item.fieldValue = item.fieldValue && typeof item.fieldValue === 'string' ? item.fieldValue?.split('/') : '';
      } else if (fieldType === 12) {
        //查找关联
        item.fieldValueName = item.fieldValue?.label || '';
        if (item.setting?.fieldType == 21) {
          item.fieldValue = item.fieldValue?.label || '';
        } else {
          item.fieldValue = item.fieldValue?.value || '';
        }
      } else if (fieldType == 16) {
        //金额
        if (fieldExt) {
          item.fieldValue = !isNaN(parseFloat(item.fieldValue)) ? tools.getPrice(item.fieldValue, fieldExt) : '';
        } else {
          // item.fieldValue = item.fieldValue ? Number(item.fieldValue) : '';
          item.fieldValue = !isNaN(parseFloat(item.fieldValue)) ? tools.getPrice(item.fieldValue) : '';
        }
      } else if (fieldType == 18) {
        //附件
        let newFieldValue = [];
        // 检查默认值存在且为有效JSON格式
        if (item.fieldValue && tools.isJSON(item.fieldValue)) {
          // 解析JSON并过滤空值，确保处理的是数组
          const parsedValue = JSON.parse(item.fieldValue);
          const validAttachments = Array.isArray(parsedValue) ? parsedValue.filter((item) => item != null) : [];
          // 为每个有效项添加default标记
          newFieldValue = validAttachments.map((attach) => ({
            ...attach,
            default: true
          }));
        }

        item.fieldValue = newFieldValue;

        if (item.setting?.fieldType == 21 && item?.setting?.business && !item.setting.business.fieldExt) {
          item.setting.business.fieldExt = JSON.stringify({ limit: 10, accept: [0] });
        }
        if (item.setting?.fieldType == 18 && !item.setting?.fieldExt) {
          item.setting.fieldExt = JSON.stringify({ limit: 10, accept: [0] });
        }
      } else if (fieldType == 23) {
        //百分比
        if (fieldExt && tools.isJSON(fieldExt)) {
          item.fieldValue = item.fieldValue ? tools.getPercentage(item.fieldValue, JSON.parse(fieldExt)?.numberFormat) : '';
        } else {
          item.fieldValue = item.fieldValue ? tools.getPercentage(item.fieldValue, 2) : '';
        }
      } else if (fieldType === 22) {
        //部门
        item.setting.fv = {
          departList:
            item.fieldValue && Array.isArray(item.fieldValue)
              ? item.fieldValue?.map((u) => {
                  return {
                    departmentName: u.name,
                    id: u.id
                  };
                })
              : [],
          userList: []
        };
        item.fieldValue = item.fieldValue && Array.isArray(item.fieldValue) ? item.fieldValue?.map((u) => u.name) : [];
      } else if (fieldType === 24) {
        //计算类型
        if (fieldExt && tools.isJSON(fieldExt)) {
          if (JSON.parse(fieldExt)?.type == 6 || JSON.parse(fieldExt)?.type == 16) {
            //6：汇总金额 16：金额
            item.fieldValue = item.fieldValue ? tools.getPrice(item.fieldValue, JSON.parse(fieldExt)?.dataType) : '';
          } else if (JSON.parse(fieldExt)?.type == 23) {
            //百分比
            item.fieldValue = item.fieldValue ? tools.getPercentage(item.fieldValue, JSON.parse(fieldExt)?.dataType) : '';
          } else if (JSON.parse(fieldExt)?.type == 5 || JSON.parse(fieldExt)?.type == 7) {
            // 数字
            //   item.fieldValue = item.fieldValue == null ? item.fieldValue : Number(item.fieldValue).toFixed(JSON.parse(fieldExt)?.dataType) ?? '';
            item.fieldValue = !isNaN(parseFloat(item.fieldValue)) ? Number(parseFloat(item.fieldValue).toFixed(JSON.parse(fieldExt).dataType)) : '';
          } else {
            item.fieldValue = item.fieldValue ?? '';
          }
        }
      } else if (fieldType === 25) {
        //查找关联多选  兼容外显字段 label 为空的 value 有值的 场景
        item.fieldValueName = item.fieldValue?.[0]?.value ? item.fieldValue.map((v) => v.label || associationEmptyText) : [];
        if (item.setting?.fieldType == 21) {
          item.fieldValue = item.fieldValue?.[0]?.value ? item.fieldValue.map((v) => v.label || associationEmptyText) : [];
        } else {
          item.fieldValue = item.fieldValue?.[0]?.value ? item.fieldValue.map((v) => v.value) : [];
        }
      } else {
        item.fieldValue = item.fieldValue ?? '';
      }
    } else {
      item.fieldValue = item.fieldValue ?? '';
    }
    // 复制场景下，requestid 等特殊字段不沿用源数据值，初始化时直接清空。
    if (options?.isCopy && aiPointsCopyClearFieldKeys.includes(item?.setting?.fieldKey)) {
      item.fieldValue = '';
      item.fieldValueName = '';
    }

    return item;
  };
  //   处理查询记录，关联记录，子表单的值 modules:字段信息
  const setRecordData = (modules, fieldType, fieldExt, fieldValue) => {
    const setTableObj = {
      ...modules,
      fieldValue
    };
    if (fieldType == 0 || fieldType == 1 || fieldType == 11 || fieldType == 13) {
      //0.文本 1.多行文本 11.超链接 13.编码
      setTableObj.fieldValue = fieldValue;
    } else if (fieldType == 2 || fieldType == 4) {
      //2.单选 4.下拉单选
      let fvType = 'number';
      if (fieldExt && tools.isJSON(fieldExt)) {
        if (typeof JSON.parse(fieldExt)?.[0]?.value == 'string') {
          fvType = 'string';
        }
      }
      setTableObj.fieldValue = fieldValue || fieldValue === 0 || fieldValue === '0' ? (fvType == 'number' ? parseInt(fieldValue) : '' + fieldValue) : '';
    } else if (fieldType == 3 || fieldType == 5) {
      //3.多选 2.单选 4.下拉单选 5.下拉多选
      setTableObj.fieldValue = fieldValue ? fieldValue.split(',') : [];
    } else if (fieldType == 6) {
      //6.人员
      const _user = [];
      const _name = [];
      const _list = fieldValue ? (Array.isArray(fieldValue) ? fieldValue : [fieldValue]) : [];
      _list.forEach((v) => {
        _user.push({
          id: v.userId || v.id || '',
          userId: v.userId || v.id || '',
          userName: v.userName,
          avatarOrigin: v.avatar || v.avatarOrigin || ''
        });
        _name.push(v.userName);
      });
      setTableObj.setting['fv'] = {
        userList: _user,
        departList: []
      };
      setTableObj.fieldValue = _name;
    } else if (fieldType == 7) {
      //7.数字
      setTableObj.fieldValue = !isNaN(parseFloat(fieldValue)) ? Number(parseFloat(fieldValue)) : '';
    } else if (fieldType == 8) {
      //8.日期
      setTableObj.fieldValue = fieldValue;
    } else if (fieldType == 9) {
      //9.日期范围
      if (tools.isJSON(fieldValue) && JSON.parse(fieldValue)?.beginDate && JSON.parse(fieldValue)?.endDate) {
        setTableObj.fieldValue = [JSON.parse(fieldValue)?.beginDate, JSON.parse(fieldValue)?.endDate];
      } else {
        setTableObj.fieldValue = null;
      }
    } else if (fieldType == 10) {
      //10.级联选择器
      setTableObj.fieldValue = fieldValue ? (Array.isArray(fieldValue) ? fieldValue : fieldValue?.split('/')) : [];
    } else if (fieldType == 12) {
      //12.查找关联
      if (fieldValue?.label && fieldValue?.value) {
        if (setTableObj?.setting?.fieldType === 21) {
          setTableObj.fieldValueName = fieldValue?.label;
        } else {
          setTableObj.fieldValue = fieldValue?.value;
        }
        setTableObj['customValue'] = {
          label: fieldValue?.label,
          value: fieldValue?.value
        };
      } else {
        setTableObj.fieldValue = fieldValue;
      }
    } else if (fieldType == 16) {
      //16.金额
      setTableObj.fieldValue = tools.getPrice(fieldValue, setTableObj?.setting?.fieldType != 21 && fieldExt ? fieldExt : 2);
    } else if (fieldType == 18) {
      //18.附件
      // 解析JSON并过滤null值
      //   setTableObj.fieldValue = fieldValue && tools.isJSON(fieldValue) ? JSON.parse(fieldValue).filter((item) => item != null) : [];

      //附件
      let newFieldValue = [];
      // 检查默认值存在且为有效JSON格式
      if (fieldValue && tools.isJSON(fieldValue)) {
        // 解析JSON并过滤空值，确保处理的是数组
        const parsedValue = JSON.parse(fieldValue);
        const validAttachments = Array.isArray(parsedValue) ? parsedValue.filter((item) => item != null) : [];
        // 为每个有效项添加default标记
        newFieldValue = validAttachments.map((attach) => ({
          ...attach,
          default: true
        }));
      }
      setTableObj.fieldValue = newFieldValue;
    } else if (fieldType == 22) {
      //22.部门
      const _depart = [];
      const _name = [];
      const _list = fieldValue ? (Array.isArray(fieldValue) ? fieldValue : [fieldValue]) : [];
      _list.forEach((v) => {
        _depart.push({
          id: v.departmentId || v.id || '',
          departmentName: v.departmentName || v.name || ''
        });
        _name.push(v.departmentName || v.name || '');
      });
      setTableObj.setting['fv'] = {
        departList: _depart,
        userList: []
      };
      setTableObj.fieldValue = _name;
    } else if (fieldType == 23) {
      //23.百分比

      setTableObj.fieldValue = !isNaN(parseFloat(fieldValue)) ? tools.getPercentage(fieldValue, JSON.parse(fieldExt)?.numberFormat || 2) : '';
    } else if (fieldType == 24) {
      //计算类型
      if (fieldExt && tools.isJSON(fieldExt)) {
        if (JSON.parse(fieldExt)?.type == 6 || JSON.parse(fieldExt)?.type == 16) {
          //6：汇总金额 16：金额
          setTableObj.fieldValue = !isNaN(parseFloat(fieldValue)) ? tools.getPrice(fieldValue, JSON.parse(fieldExt)?.dataType) : '';
        } else if (JSON.parse(fieldExt)?.type == 23) {
          //百分比
          setTableObj.fieldValue = !isNaN(parseFloat(fieldValue)) ? tools.getPercentage(fieldValue, JSON.parse(fieldExt)?.dataType) : '';
        } else if (JSON.parse(fieldExt)?.type == 5 || JSON.parse(fieldExt)?.type == 7) {
          // 数字
          setTableObj.fieldValue = !isNaN(parseFloat(fieldValue)) ? Number(parseFloat(fieldValue)) : '';
        } else {
          setTableObj.fieldValue = fieldValue;
        }
      }
    } else if (fieldType == 25) {
      //25.查找关联多选
      if (fieldValue?.length > 0) {
        setTableObj.fieldValue = fieldValue.map((fv) => fv.value);
        setTableObj['customValue'] = fieldValue; //fieldValue.map((fv) => fv.label);
      } else {
        setTableObj.fieldValue = fieldValue;
      }
    } else {
      setTableObj.fieldValue = fieldValue;
    }
    return setTableObj;
  };

  //初始化处理编辑关联对象表格数据 (type:35,31,30)
  const setEditFormTable = (_modules, list) => {
    console.log(_modules, list, 'console.log(_modules, list');
    const getBusinessList = [];
    for (let i = 0; i < list?.length; i++) {
      //这里是为了兼容table表格返回的字段key不一致，可能某条数据没有A字段，会读取到上一条数据的A字段
      const modules = JSON.parse(JSON.stringify(_modules));
      const obj = [];
      for (let j = 0; j < modules?.length; j++) {
        const key = modules[j]?.setting?.fieldKey || modules[j]?.value;
        if (key in list[i]) {
          const fieldType = modules[j]?.setting?.fieldType;
          const fieldExt = modules[j]?.setting?.fieldExt;

          if (fieldType == 27) {
            //子表单
            if (list[i][key]?.length > 0) {
              modules[j].modules = list[i][key].map((item) =>
                modules[j]?.modules?.map((module) => {
                  return { ...setRecordData(module, module.setting.fieldType, module.setting.fieldExt, item?.[module.setting.fieldKey] || null), detailId: item?.id };
                })
              );
            } else {
              modules[j].modules = [modules[j]?.modules?.map((module) => ({ ...module }))];
            }
          } else {
            if (fieldType == 21) {
              //引用字段
              modules[j].fieldValue = list[i][key];
            } else {
              modules[j] = { ...setRecordData(modules[j], fieldType, fieldExt, list[i]?.[key] || null) };
            }
          }

          modules[j]['newOriginBusinessId'] = list[i]?.newOriginBusinessId; //这是销售合同，订单添加报价单明细时，订单添加合同明细时的唯一值
          modules[j]['detailEntityId'] = list[i]?.detailEntityId; //这是销售合同，订单添加报价单明细时，订单添加合同明细时记录的entityId
        }
        modules[j]['detailId'] = list[i].id;
        modules[j]['LOGIC_ROLE_PERMISSION'] = list[i].LOGIC_ROLE_PERMISSION;
        modules[j]['PERMISSION'] = list[i].PERMISSION;
        modules[j]['lockedOrigin'] = list[i].lockedOrigin;
        obj.push({ ...JSON.parse(JSON.stringify(modules[j])) });
      }
      getBusinessList.push(obj);
    }
    return getBusinessList;
  };

  //新增编辑初始化时处理表单的数据
  const processInnerItem = (item, opType, str) => {
    const isCopy = str === true || str === 1;
    // 分组

    if (item?.type == 20) {
      //这是表单的基础信息
      if (opType == 30) {
        //新增
        return setAddForm(item);
      }
      if (opType == 40) {
        if (str == 'conversion') {
          return (item?.fieldValue == 0 || item?.fieldValue) && item?.fieldValue !== '' && (typeof item?.fieldValue === 'number' || item?.fieldValue?.length) ? setEditForm(item) : setAddForm(item);
        } else {
          //编辑
          return setEditForm(item, { isCopy });
        }
      }
    }
    // 表格
    if (item?.type == 30) {
      return item;
    }
    if (item?.modules) {
      return {
        ...item,
        modules: item.modules?.map((el) => processInnerItem(el, opType, str))
      };
    } else {
      return item;
    }
  };

  const setFieldValue = (customForm, opType, str) => {
    return customForm?.map((outerList) => {
      if (outerList?.modules) {
        return {
          ...outerList,
          modules: outerList.modules.map((item) => processInnerItem(item, opType, str))
        };
      }
      return outerList;
    });
  };

  //保存时对数据处理
  const saveFormData = async (viewId, entity, formData, detailList, type, fromType) => {
    data.sendFormData = {};
    const params = {
      id: viewId,
      entity: entity,
      data: {},
      businessList: []
    };
    formData.forEach((item) => {
      if (item?.modules) {
        item?.modules.forEach((list) => {
          if (list.type == 20 && list.setting?.fieldType != 21 && list.setting?.fieldType != 24) {
            //引用字段，计算字段 不上送
            // if ((list?.display == 2 && list?.conditionsDisplay == 1) || list?.display == 1) {
            //显示了才上传数据
            params.data[list.setting.fieldKey] = getFormFieldValue(list, 2, fromType);
            if (type == 40) {
              //编辑时上传id
              params.data['id'] = data.layoutDetailModules[0]?.mainTableBusinessId;
            }
            // }
          }
          //   关联表格或者子表单
          if ((list.type == 30 || list.type == 35) && list?.modules) {
            if (detailList?.[list.id] && detailList?.[list.id]?.length > 0 && ((list?.display == 2 && list?.conditionsDisplay == 1) || list?.display == 1)) {
              params.businessList = params.businessList.concat(combineItemsTable(list.id, list.businessData, detailList?.[list.id], type, 2));
            } else {
              //表格数据为空传递空数组，方便后台处理数据
              params.businessList = params.businessList.concat([{ id: list.id, entity: list.businessData, data: {} }]);
            }
          }
        });
      }
    });
    data.sendFormData = params;
    return data;
  };
  // 处理表格上传的数据
  const combineItemsTable = (listId, businessData, modules, type, from) => {
    const getBusinessList = [];
    modules?.forEach((list) => {
      const obj = {};
      list.forEach((item) => {
        if (from == 2) {
          //新增/编辑/复制保存时
          if (item?.setting?.fieldType == 27) {
            //子表单
            obj[item?.setting?.fieldKey] = [];

            if (item?.modules?.length > 0) {
              item?.modules?.forEach((parentItem) => {
                const childObj = {};
                parentItem?.forEach((childItem) => {
                  childObj[childItem?.setting?.fieldKey] = getFormFieldValue(childItem, 2);
                });
                delete childObj.id;
                if (type == 40 && parentItem[0]?.detailId) {
                  //编辑时且不是新增的明细才上送id
                  childObj.id = parentItem[0].detailId;
                }
                obj[item?.setting?.fieldKey].push({ entity: item?.setting?.fieldExt, data: childObj });
              });
            }
          } else {
            //数据保存时引用字段和计算字段不送
            if (item?.setting?.fieldType != 21 && item?.setting?.fieldType != 24) {
              obj[item?.setting?.fieldKey] = getFormFieldValue(item, from);
            }
          }

          //   delete obj.id;
          //   if (type == 40 && list[0].detailId) {
          //     //编辑时且不是新增的明细才上送id
          //     obj.id = list[0].detailId;
          //   }
        } else {
          //实时计算
          if (item?.setting?.fieldType != 21) {
            obj[item?.setting?.fieldKey] = getFormFieldValue(item, from);
          }
        }
        delete obj.id;
        if (type == 40 && list[0]?.detailId) {
          //编辑时且不是新增的明细才上送id
          obj.id = list[0].detailId;
        }
      });
      getBusinessList.push({ id: listId, entity: businessData, data: obj });
    });

    return getBusinessList;
  };

  //   处理表单字段数据
  const getFormFieldValue = (list, type, fromType) => {
    let fieldValue = list.fieldValue ?? '';
    const fieldType = list.setting?.fieldType;
    const fieldExt = list.setting?.fieldExt;
    if (fieldType === 3 || fieldType === 5) {
      fieldValue = fieldValue && Array.isArray(fieldValue) ? fieldValue?.join(',') : '';
    } else if (fieldType === 6) {
      //人员传递参数是字符串ID以逗号分割
      const userIds = list.setting?.fv?.userList?.map((u) => u.id)?.join(',');
      fieldValue = userIds || '';
    } else if (fieldType === 9) {
      const hasValue = tools.hasDateRange(fieldValue);
      const v = { beginDate: fieldValue?.[0], endDate: fieldValue?.[1] };
      fieldValue = hasValue ? JSON.stringify(v) : '';
    } else if (fieldType === 10) {
      fieldValue = fieldValue && Array.isArray(fieldValue) ? fieldValue?.join('/') : '';
    } else if (fieldType === 12) {
      fieldValue = fieldValue?.value || list?.customValue?.value || fieldValue || '';
    } else if (fieldType === 16) {
      fieldValue = !isNaN(parseFloat(fieldValue)) ? tools.setPrice(fieldValue) : '';
    } else if (fieldType === 18) {
      if (fromType === 'addOrEdit' && Array.isArray(fieldValue)) {
        fieldValue.forEach((fItem) => {
          if (fItem?.default) {
            delete fItem.default;
          }
        });
      }
      // 过滤空值并转换为JSON字符串
      const validAttachments = Array.isArray(fieldValue) ? fieldValue.filter((item) => item != null) : [];

      fieldValue = validAttachments?.length > 0 && Array.isArray(validAttachments) ? JSON.stringify(validAttachments) : '';
    } else if (fieldType === 23) {
      fieldValue = !isNaN(parseFloat(fieldValue)) ? tools.setPercentage(fieldValue, fieldExt) : '';
    } else if (fieldType === 22) {
      //部门传递参数是字符串ID以逗号分割
      const departIds = list.setting?.fv?.departList?.map((u) => u.id)?.join(',');
      fieldValue = departIds || '';
    } else if (fieldType === 26) {
      // 富文本
      if (fieldValue === '<p><br></p>') {
        fieldValue = '';
      }
      console.log('富文本值', fieldValue);
    }
    if (type == 1) {
      //实时计算的接口需要上送计算字段
      if (fieldType === 24) {
        //计算类型
        if (fieldExt && tools.isJSON(fieldExt)) {
          if (JSON.parse(fieldExt)?.type == 6 || JSON.parse(fieldExt)?.type == 16) {
            //6：汇总金额  16：金额
            fieldValue = !isNaN(parseFloat(fieldValue)) ? tools.setPrice(fieldValue) : '';
          } else if (JSON.parse(fieldExt)?.type == 23) {
            //百分比
            fieldValue = !isNaN(parseFloat(fieldValue)) ? tools.setPercentage(fieldValue, JSON.parse(fieldExt)?.dataType) : '';
          } else if (JSON.parse(fieldExt)?.type == 5 || JSON.parse(fieldExt)?.type == 7) {
            fieldValue = !isNaN(parseFloat(fieldValue)) ? Number(fieldValue) : fieldValue;
          }
        }
      }
    }

    return fieldValue;
  };
  //计算字段获取结果赋值
  const setComputeingVal = (el, result) => {
    for (const key in result) {
      if (key == el.setting.fieldKey) {
        const fieldExt = el.setting?.fieldExt && tools.isJSON(el.setting?.fieldExt) ? JSON.parse(el.setting.fieldExt) : el.setting.fieldExt;
        //2025年05月26日14:32:08 页面包含计算字段+其他对象汇总字段时，汇总计算显示错误，未进行/10000处理
        if (fieldExt?.type == 6 || fieldExt?.type == 16) {
          //6：汇总金额 16：金额
          el.fieldValue = !isNaN(parseFloat(result[key])) ? tools.getPrice(result[key], fieldExt?.dataType) : result[key] ?? '';
        } else if (fieldExt?.type == 23) {
          //百分比
          el.fieldValue = !isNaN(parseFloat(result[key])) ? tools.getPercentage(result[key], fieldExt?.dataType) : result[key] ?? '';
        } else if (fieldExt?.type == 7) {
          //数字
          el.fieldValue = !isNaN(parseFloat(result[key])) ? Number(parseFloat(result[key]).toFixed(fieldExt?.dataType ?? 2)) : result[key] ?? '';
        } else {
          //文本 日期
          el.fieldValue = result[key] ?? '';
        }
      }
    }
    return el;
  };
  //   获取实时计算字段结果 from:1 基础信息 from：2 关联表格（单条编辑） from：3 关联表格(多条批量编辑时)
  const getComputeing = async (options) => {
    const { viewId, entity, formData, detailList, type, id, from, modulesItem } = options || {};
    const params = {
      id: viewId,
      entity: entity,
      paramVo: {
        // id,
        data: {},
        businessList: []
      }
    };
    formData?.forEach((item) => {
      if (item?.modules) {
        item?.modules.forEach((list) => {
          if (list.type == 20 && list.setting?.fieldType != 21) {
            params.paramVo.data[list.setting.fieldKey] = getFormFieldValue(list, 1);
            params.paramVo.data['id'] = id;
          }
          if (list.type == 30 && list?.modules && from == 1) {
            if (detailList?.[list.id] && detailList?.[list.id]?.length > 0) {
              params.paramVo.businessList = params.paramVo.businessList.concat(combineItemsTable(list.id, list.businessData, detailList[list.id], type, 1));
            } else {
              //表格数据为空传递空数组，方便后台处理数据
              params.paramVo.businessList = params.paramVo.businessList.concat([{ id: list.id, entity: list.businessData, data: {} }]);
            }
          }
        });
      }
    });
    if (from == 2 || from == 3) {
      //关联表格
      if (detailList && detailList?.length > 0) {
        if (from == 2) {
          const getBusinessList = { id: modulesItem.id, entity: modulesItem.businessData, data: {} };
          detailList?.forEach((list) => {
            //实时计算 过滤掉引用字段
            if (list?.setting?.fieldType != 21) {
              getBusinessList.data[list?.setting?.fieldKey] = getFormFieldValue(list, 1);
            }
          });
          getBusinessList.data['id'] = detailList[0]?.detailId || null; //关联表格的id
          params.paramVo.businessList = params.paramVo.businessList.concat([getBusinessList]);
        }
        if (from == 3) {
          const getDetailList = JSON.parse(JSON.stringify(detailList));
          getDetailList?.forEach((list) => {
            //实时计算 过滤掉引用字段
            const getData = { id: modulesItem.id, entity: modulesItem.businessData, data: {} };
            list?.forEach((item) => {
              if (item?.setting?.fieldType != 21) {
                getData.data[item?.setting?.fieldKey] = getFormFieldValue(item, 1);
              }
            });
            getData.data['id'] = list[0]?.detailId || null; //关联表格的id
            params.paramVo.businessList = params.paramVo.businessList.concat([getData]);
          });
        }
      } else {
        //表格数据为空传递空数组，方便后台处理数据
        params.paramVo.businessList = params.paramVo.businessList.concat([{ id: modulesItem.id, entity: modulesItem.businessData, data: {} }]);
      }
    }
    try {
      const json = await formulaFieldService.getCalculationResults(params);
      const result = json?.result || [];
      //   console.log(result);
      let errorMap = null;
      if (result && Object.keys(result).length > 0) {
        if (from == 1) {
          //基础信息
          errorMap = result?.errorData;
          formData?.forEach((list) => {
            if (list?.modules) {
              list?.modules.forEach((item) => {
                if (item.type == 20 && item.setting.fieldType == 24) {
                  //是计算字段
                  item = setComputeingVal(item, result);
                } else {
                  if (item.type == 30) {
                    result?.businessList?.forEach((businessItem) => {
                      if (businessItem.entity == item.businessData) {
                        detailList?.[item.id]?.[businessItem.rowId].forEach((detailItem) => {
                          if (detailItem.setting.fieldType == 24) {
                            detailItem = setComputeingVal(detailItem, businessItem.data);
                          }
                        });
                      }
                    });
                  }
                }
              });
            }
          });
        }
        if (from == 2) {
          //关联表格
          const getFieldList = result?.businessList?.find((el) => el.entity == modulesItem.businessData);
          errorMap = getFieldList?.errorData;
          detailList?.forEach((item) => {
            if (item.type == 20 && item.setting.fieldType == 24) {
              //是计算字段
              item = setComputeingVal(item, getFieldList.data);
            }
          });
        }
        if (from == 3) {
          //关联表格(多条)
          const getFieldList = result?.businessList?.filter((el) => el.entity == modulesItem.businessData);
          // console.log('getFieldList----',getFieldList)
          detailList?.forEach((list, index) => {
            list?.forEach((item) => {
              if (item.type == 20 && item.setting.fieldType == 24) {
                const _rowItem = getFieldList?.find((el) => el.rowId == index);
                //是计算字段
                item = setComputeingVal(item, _rowItem?.data);
              }
            });
          });
        }
        return from == 1 ? { formData, errorMap } : { detailList, errorMap };
      } else {
        return from == 1 ? { formData, errorMap } : { detailList, errorMap };
      }
    } catch (e) {
      return from == 1 ? { formData } : { detailList };
    }
  };
  //获取新增模块布局配置
  const getAddLayoutConfig = async (params) => {
    if (params) {
      try {
        const json = await layoutService.getLayoutAddModules(params);
        data.layoutAddModules = json?.result && json?.result[0]?.modules ? setFieldValue(json?.result, 30) : [];

        return data;
      } catch (e) {
        return [];
      }
    } else {
      return [];
    }
  };
  //获取编辑模块布局配置
  const getEditLayoutConfig = async (params) => {
    if (params) {
      const getParams = { viewId: params.viewId, businessId: params.businessId, entity: params.entity };
      if (params?.copy) {
        getParams.copy = params.copy; //复制
      }
      try {
        const json = await layoutService.updateLayoutAddModules(getParams);
        data.layoutDetailModules = json?.result && json?.result[0]?.modules ? setFieldValue(json?.result, 40, getParams?.copy) : [];
        return data;
      } catch (e) {
        return [];
      }
    } else {
      return [];
    }
  };
  // 设置详情页面的loading状态
  const setLayoutLoadingStatus = (status) => {
    data.layoutDetailLoading = !!status;
  };
  //获取详情页面模块配置
  const getLayoutDetailConfigArea = async (params) => {
    data.layoutDetailLoading = true;
    data.layoutDetailAllList = [];
    console.log('params', params);
    if (params) {
      const getParams = {
        entity: params.entity,
        businessId: params.businessId
      };
      if (params.viewId) {
        getParams.viewId = params.viewId;
      }
      try {
        const res = await layoutService.getLayoutDetailModules(getParams);
        const rr = res.result;
        data.layoutDetailConfig = rr || null;
        data.layoutDetailAllList = rr?.modules;
        data.logicRolePermission = rr?.logicRolePermission;
        data.layoutAllFields = rr?.data;
        data.layoutMainField = rr?.mainFieldSetting || {};
        data.layoutDetailLoading = false;
        data.splitType = rr?.data?.splitType;
        return { type: res.error ? 2 : 1, res: res.error ? res : data };
      } catch (e) {
        console.log(265, e);
        data.layoutDetailLoading = false;
        return { type: 3, res: e };
      }
    } else {
      return { type: 4, res: [] };
    }
  };

  // 列表单选 多选反显示
  const showFieldsLabel = (v, fieldExt, fieldType) => {
    console.log(65, v, fieldExt, fieldType);
    if (!v && !fieldExt) return v ?? '-';
    // console.log(354, fieldExt);
    const ext = tools.isJSON(fieldExt) ? JSON.parse(fieldExt) : [];
    let fields = undefined;
    // 单选
    if (fieldType === 2 || fieldType === 4) {
      // console.log(359, ext);
      fields = ext?.find((el) => el.value == v);
      return fields?.label || v;
    }
    // 多选
    if (fieldType === 3 || fieldType === 5) {
      const val = v + '';
      fields = ext?.filter((el) => val.split(',')?.indexOf(el.value) > -1);
      return (fields && fields?.length && fields.map((el) => el.label).join('/')) || v;
    }
    if (fieldType === 10) {
      // 正在开发中
      const kArr = v && Array.isArray(v) ? v || [] : typeof v === 'string' ? v?.split('/') || [] : [];
      // const k = kArr[kArr.length - 1];
      // // console.log(86, k, kArr);
      // const val = tools.getTreeDeepArr(k, ext);
      // const text = val?.iLabel?.join('/');
      // console.log(88, val.iLabel, text, k);
      // 第二种方式
      let text = '';
      let curChildren = ext;
      for (let index = 0; index < kArr?.length; index++) {
        const element = kArr[index];
        const cur = curChildren?.find((el) => el.value === element);
        curChildren = cur?.children || [];
        if (cur) text += `${index ? '/' : ''}${cur.label}`;
      }
      return (text || v) ?? '';
    }

    // fields = ext?.filter((el) => val.split(',')?.indexOf(el.value) > -1);
    // console.log(67, v, list);
    return v ?? '';
  };

  // 处理一些多选，单选级联数据( 分割的符号 symbol='/')
  const getFieldLabel = (v, fieldExt, fieldType, symbol = '/') => {
    if (!v && !fieldExt) return v ?? '-';
    // console.log(354, fieldExt);
    const ext = tools.isJSON(fieldExt) ? JSON.parse(fieldExt) : [];
    let fields = undefined;
    // 单选
    if (fieldType === 2 || fieldType === 4) {
      // console.log(359, ext);
      fields = ext?.find((el) => el.value == v);
      return fields?.label || v || '-';
    }
    // 多选
    if (fieldType === 3 || fieldType === 5) {
      const val = v + '';
      fields = ext?.filter((el) => val.split(',')?.indexOf(el.value) > -1);

      const resultText = (fields && fields?.length && fields.map((el) => el.label).join(symbol)) || v || '-';
      return resultText;
    }
    // 级联选择
    if (fieldType === 10) {
      const kArr = v && Array.isArray(v) ? v || [] : typeof v === 'string' ? v?.split('/') || [] : [];
      // const k = kArr[kArr.length - 1];
      // // console.log(86, k, kArr);
      // const val = tools.getTreeDeepArr(k, ext);
      // const text = val?.iLabel?.join('/');
      // console.log(88, val.iLabel, text, k);
      // 第二种方式
      let text = '';
      let curChildren = ext;
      for (let index = 0; index < kArr?.length; index++) {
        const element = kArr[index];
        const cur = curChildren?.find((el) => el.value === element);
        curChildren = cur?.children || [];
        if (cur) text += `${index ? '/' : ''}${cur.label}`;
      }
      return (text || v) ?? '-';
    }
    // fields = ext?.filter((el) => val.split(',')?.indexOf(el.value) > -1);
    // console.log(67, v, list);
    return v ?? '';
  };
  //列表字段编辑时处理列表的value拿不到的问题
  const getFieldValue = (fieldValue, fieldExt, fieldType) => {
    if (!fieldValue && !fieldExt) return fieldValue ?? '';

    const ext = tools.isJSON(fieldExt) ? JSON.parse(fieldExt) : [];
    let fields = undefined;
    // 单选
    if (fieldType === 2 || fieldType === 4) {
      fields = ext?.find((el) => el.label == fieldValue);
      return fields?.value || fieldValue || '';
    }
    // 多选
    if (fieldType === 3 || fieldType === 5) {
      const val = fieldValue + '';
      fields = ext?.filter((el) => val.split(',')?.indexOf(el.label) > -1);
      return (fields && fields?.length && fields.map((el) => el.value).join('/')) || fieldValue || '';
    }
    // 级联选择
    if (fieldType === 10) {
      const kArr = fieldValue && typeof fieldValue === 'string' ? fieldValue?.split('/') : [];
      // 第二种方式
      let text = '';
      let curChildren = ext;
      for (let index = 0; index < kArr?.length; index++) {
        const element = kArr[index];
        const cur = curChildren?.find((el) => el.label === element);
        curChildren = cur?.children || [];
        if (cur) text += `${index ? '/' : ''}${cur.value}`;
      }
      return (text || fieldValue) ?? '';
    }
    return fieldValue ?? '';
  };
  //处理高级筛选字段
  const fitlterFields = () => {
    data.filterSearchList.filterSelect = [];
    data.filterSearchList.searchSelect = [];
    data.searchList?.forEach((item) => {
      if (item.fieldType === 0 || item.fieldType === 1 || item.fieldType === 12 || item.fieldType === 13) {
        if ((data.type == 1 || data.type == 2) && checkboxFieldList.indexOf(item.fieldKey) !== -1) {
          //针对线索，客户，商机，特殊处理
          data.filterSearchList.filterSelect.push({
            type: 'checkbox',
            multiple: true,
            label: item.fieldName,
            name: item.fieldKey,
            checkAll: true,
            data: checkboxOptions
          });
        } else {
          if (inputFieldList.indexOf(item.fieldKey) == -1) {
            const sv = { label: item.fieldName, value: item.fieldKey, type: item.type, fieldType: item.fieldType, fieldKey: item.fieldKey };
            data.filterSearchList.searchSelect.push(sv);
          }
        }
      } else if (item.fieldType === 2 || item.fieldType === 3) {
        data.filterSearchList.filterSelect.push({
          type: 'checkbox',
          multiple: true,
          label: item.fieldName,
          name: item.fieldKey,
          checkAll: true,
          data: JSON.parse(item.fieldExt)
        });
      } else if (item.fieldType === 4 || item.fieldType === 5) {
        const tmp = {
          type: 'select',
          label: item.fieldName,
          multiple: true,
          name: item.fieldKey,
          maxTagCount: 1,
          value: item.fieldValue || [],
          data: item?.fieldExt ? JSON.parse(item?.fieldExt) : item.fieldExt
        };
        data.filterSearchList.filterSelect.push(tmp);
      } else if (item.fieldType === 6) {
        if (item.fieldKey !== 'lastUpdateUser') {
          data.filterSearchList.filterSelect.push({
            type: 'member',
            label: item.fieldName,
            name: item.fieldKey,
            tree: {
              checkDepartment: true
            },
            placeholder: `${i18n.global.t('请选择')}${item.fieldName}`
          });
        }
      } else if (item.fieldType === 22) {
        //部门

        data.filterSearchList.filterSelect.push({
          type: 'member',
          label: item.fieldName,
          name: item.fieldKey,
          tree: {
            checkDepartment: true,
            isAll: false,
            data: [], // 数组 必传
            checkUser: false
          },
          placeholder: `${i18n.global.t('请选择')}${item.fieldName}`
        });
      }
      // else if (item.fieldType === 8 || item.fieldType === 9) { //后端暂时不支持日期区间查询所以注释掉
      else if (item.fieldType === 8) {
        data.filterSearchList.filterSelect.push({
          type: 'datePicker',
          label: item.fieldName,
          name: item.fieldKey
        });
      } else if (item.fieldType === 10) {
        data.filterSearchList.filterSelect.push({
          type: 'cascader',
          label: item.fieldName,
          pathMode: true,
          // checkStrictly: true,
          multiple: true,
          name: item.fieldKey,
          data: item.fieldExt ? JSON.parse(item.fieldExt) : item.fieldExt
        });
      }
    });
    return data.filterSearchList;
  };

  // 获取线索池搜索项
  const getLeadPoolSelect = async (params) => {
    console.log('poolSelect获取参数');
    if (params) {
      try {
        const res = await poolClueService.getPoolclue();
        if (!res.error) {
          console.log(1190, res.result);
          data.filterSearchList.leadPoolSelect = res.result;
          return res.result;
        } else {
          return [];
        }
      } catch (e) {
        console.log(265, e);
        return [];
      }
    }
  };

  //处理高级筛选字段
  const fitlterLayoutFields = () => {
    data.filterSearchList.filterSelect = [];
    data.filterSearchList.searchSelect = [];
    if (data.fieldsListAll?.filters?.length > 0) {
      data.fieldsListAll?.filters?.forEach((item) => {
        if (item.fieldType === 21) {
          //引用字段
          item.fieldType = item?.business?.fieldType;
          item.fieldExt = item?.business?.fieldExt;
        }
        if (item.fieldType === 0 || item.fieldType === 1 || item.fieldType === 12 || item.fieldType === 13) {
          if ((data.type == 1 || data.type == 2) && checkboxFieldList.indexOf(item.fieldKey) !== -1) {
            //针对线索，客户，商机，特殊处理
            data.filterSearchList.filterSelect.push({
              type: 'checkbox',
              multiple: true,
              label: item.fieldName,
              name: item.fieldKey,
              checkAll: true,
              data: checkboxOptions
            });
          }
        } else if (item.fieldType === 2 || item.fieldType === 3) {
          data.filterSearchList.filterSelect.push({
            type: 'checkbox',
            multiple: true,
            label: item.fieldName,
            name: item.fieldKey,
            checkAll: true,
            data: JSON.parse(item.fieldExt)
          });
        } else if (item.fieldType === 4 || item.fieldType === 5) {
          const tmp = {
            type: 'select',
            label: item.fieldName,
            multiple: true,
            name: item.fieldKey,
            maxTagCount: 1,
            value: item.fieldValue || [],
            data: item?.fieldExt ? JSON.parse(item?.fieldExt) : item.fieldExt
          };
          data.filterSearchList.filterSelect.push(tmp);
        } else if (item.fieldType === 6) {
          if (item.fieldKey !== 'lastUpdateUser') {
            data.filterSearchList.filterSelect.push({
              type: 'member',
              label: item.fieldName,
              name: item.fieldKey,
              tree: {
                checkDepartment: true
              },
              placeholder: `${i18n.global.t('请选择')}${item.fieldName}`
            });
          }
        } else if (item.fieldType === 7) {
          data.filterSearchList.filterSelect.push({
            type: 'number',
            label: item.fieldName,
            name: item.fieldKey,
            select: {},
            placeholder: '请输入数字'
          });
        } else if (item.fieldType === 16) {
          data.filterSearchList.filterSelect.push({
            type: 'number',
            label: item.fieldName,
            name: item.fieldKey,
            select: {},
            placeholder: '请输入金额'
          });
        } else if (item.fieldType == 18) {
          data.filterSearchList.filterSelect.push({
            type: 'radio',
            multiple: false,
            label: item.fieldName,
            name: item.fieldKey,
            checkAll: true,
            data: [
              {
                isEnabled: true,
                label: '已上传',
                value: 'not_null'
              },
              {
                isEnabled: true,
                label: '未上传',
                value: 'null'
              }
            ]
          });
        } else if (item.fieldType === 22) {
          //部门

          data.filterSearchList.filterSelect.push({
            type: 'member',
            label: item.fieldName,
            name: item.fieldKey,
            tree: {
              checkDepartment: true,
              isAll: false,
              data: [], // 数组 必传
              checkUser: false
            },
            placeholder: `${i18n.global.t('请选择')}${item.fieldName}`
          });
        }
        // else if (item.fieldType === 8 || item.fieldType === 9) { //后端暂时不支持日期区间查询所以注释掉
        else if (item.fieldType === 8) {
          data.filterSearchList.filterSelect.push({
            type: 'datePicker',
            label: item.fieldName,
            name: item.fieldKey
          });
        } else if (item.fieldType === 10) {
          data.filterSearchList.filterSelect.push({
            type: 'cascader',
            label: item.fieldName,
            pathMode: true,
            // checkStrictly: true,
            multiple: true,
            name: item.fieldKey,
            data: item.fieldExt ? JSON.parse(item.fieldExt) : item.fieldExt
          });
        } else if (item.fieldType === 23) {
          data.filterSearchList.filterSelect.push({
            type: 'number',
            label: item.fieldName,
            name: item.fieldKey,
            select: {},
            placeholder: '请输入数字'
            // precision: tools.isJSON(item.fieldExt) ? Number(JSON.parse(item.fieldExt)?.numberFormat) : 2
          });
        } else if (item.fieldType === 24) {
          // console.log(725, item.fieldExt, tools.isJSON(item.fieldExt));
          const fieldExt = tools.isJSON(item.fieldExt) ? JSON.parse(item.fieldExt) : item.fieldExt;
          if (fieldExt.type == 6 || fieldExt.type == 16 || fieldExt.type == 5 || fieldExt.type == 7) {
            //金额数字
            data.filterSearchList.filterSelect.push({
              type: 'number',
              label: item.fieldName,
              name: item.fieldKey,
              select: {},
              placeholder: fieldExt.type == 6 || fieldExt.type == 16 ? '请输入金额' : '请输入数字',
              data: fieldExt
              // precision: tools.isJSON(item.fieldExt) ? Number(JSON.parse(item.fieldExt)?.numberFormat) : 2
            });
          }
          if (fieldExt.type == 8) {
            //日期
            data.filterSearchList.filterSelect.push({
              type: 'datePicker',
              label: item.fieldName,
              name: item.fieldKey
            });
          }
          if (fieldExt.type == 23) {
            //百分比
            data.filterSearchList.filterSelect.push({
              type: 'number',
              label: item.fieldName,
              name: item.fieldKey,
              select: {},
              placeholder: '请输入数字'
              // precision: tools.isJSON(item.fieldExt) ? Number(JSON.parse(item.fieldExt)?.numberFormat) : 2
            });
          }
        }
      });
    }
    if (data.fieldsListAll?.dropdowns?.length > 0) {
      data.fieldsListAll?.dropdowns?.forEach((item) => {
        const sv = { label: item.fieldName, value: item.fieldKey, type: item.type, fieldType: item.fieldType, fieldKey: item.fieldKey };
        data.filterSearchList.searchSelect.push(sv);
      });
    }
    return data.filterSearchList;
  };
  // 处理全部等下拉筛选列表
  // 获取布局详情下所有字段信息--有特殊字段判断按钮权限时使用
  const getLayoutAllFields = async (params) => {
    data.layoutAllFields = [];
    try {
      if (params) {
        const json = await layoutService.getLayoutAllFields(params);
        if (!json.error) {
          data.layoutAllFields = json.result;
        } else {
          return [];
        }
      }
    } catch (e) {
      console.log(e);
    }
  };
  //处理高级筛选的参数
  const getFilterParams = (v, viewId, entity) => {
    const filterParams = { conditions: [], scope: entity == 101 ? null : v.limits, id: viewId, entity: entity };

    const newFilterParams = Object.keys(v).filter((keys) => {
      return keys != 'limits';
    });
    if ((v && JSON.stringify(v) != '{}' && newFilterParams?.length) || entity == 101) {
      if (userInfo.orgId == huaYingOrdId && entity == 2) {
        filterParams.conditions.push({
          operation: 'and',
          field: '',
          value: '',
          isGroup: true,
          children: [
            { operation: 'or', field: '', value: '', isGroup: true, children: [] },
            { operation: 'and', field: '', value: '', isGroup: true, children: [] }
          ]
        });
      } else {
        filterParams.conditions.push({
          operation: 'and',
          field: '',
          value: '',
          isGroup: true,
          children: []
        });
      }
    }

    data.filterSearchList.searchSelect?.forEach((item) => {
      if (v?.search1?.selectVal === item.fieldKey) {
        //存在字段名称重复的问题
        if (userInfo.orgId == huaYingOrdId && entity == 2) {
          if (item.fieldKey == 'customerName' || item.fieldKey == 'input_NjdrP7') {
            //华映资本特殊处理  LP主体：customerName 机构品牌：input_NjdrP7
            const fieldKey = item.fieldKey == 'customerName' ? 'input_NjdrP7' : 'customerName';
            filterParams.conditions[0]['children'][0]['children'].push({ field: item.fieldKey, value: v?.search1?.val || '', operation: 'like', isGroup: false });
            filterParams.conditions[0]['children'][0]['children'].push({ field: fieldKey, value: v?.search1?.val || '', operation: 'like', isGroup: false });
          } else {
            filterParams.conditions[0]['children'][0]['children'].push({ field: item.fieldKey, value: v?.search1?.val || '', operation: 'like', isGroup: false });
          }
        } else {
          filterParams.conditions[0]['children'].push({ field: item.fieldKey, value: v?.search1?.val || '', operation: 'like', isGroup: false });
        }
      }
    });
    let tempstr;
    data.enableList?.forEach((item) => {
      Object.entries(v)?.forEach((m) => {
        if (item.fieldKey === m[0]) {
          if (item.fieldType === 21) {
            //引用字段
            item.fieldType = item?.business?.fieldType;
            item.fieldExt = item?.business?.fieldExt;
          }
          if (item.fieldType === 10) {
            tempstr = { field: item.fieldKey, value: m[1]?.map((el) => el.join('/')).join(',') || '', operation: 'in', isGroup: false };
          } else if (item.fieldType === 18) {
            tempstr = { field: item.fieldKey, value: '', operation: m[1], isGroup: false };
          } else if (item.fieldType === 6 || item.fieldType === 22) {
            //人员和部门
            const v = {
              userIds: m[1]?.userList.map((u) => u.id),
              departIds: m[1]?.departList.map((u) => Number(u.id))
            };
            tempstr = { field: item.fieldKey, value: v, operation: 'in', isGroup: false };
          } else if (item.fieldType === 7) {
            tempstr = { field: item.fieldKey, value: m?.[1]?.val === 0 ? 0 : m?.[1]?.selectVal != 'null' && m?.[1]?.selectVal != 'not_null' ? Number(m?.[1]?.val) : null, operation: m?.[1]?.selectVal, isGroup: false };
          } else if (item.fieldType === 16) {
            tempstr = { field: item.fieldKey, value: m?.[1]?.val === 0 ? 0 : m?.[1]?.selectVal != 'null' && m?.[1]?.selectVal != 'not_null' ? Number(tools.setPrice(m?.[1]?.val)) : null, operation: m?.[1]?.selectVal, isGroup: false };
          } else if (item.fieldType === 8) {
            const paramsDate = { beginDate: dayjs(m[1][0]).format('YYYY-MM-DD'), endDate: dayjs(m[1][1]).format('YYYY-MM-DD') };
            tempstr = { field: item.fieldKey, value: paramsDate ? JSON.stringify(paramsDate) : '{}', operation: 'between', isGroup: false };
          } else if (item.fieldType === 9) {
            const paramsDate = { beginDate: m[1][0], endDate: m[1][1] };
            tempstr = { field: item.fieldKey, value: paramsDate, operation: 'between', isGroup: false };
          } else if (item.fieldType === 23) {
            tempstr = { field: item.fieldKey, value: m?.[1]?.val === 0 ? 0 : m?.[1]?.selectVal != 'null' && m?.[1]?.selectVal != 'not_null' ? Number(divideAndRound(m?.[1]?.val)) : null, operation: m?.[1]?.selectVal, isGroup: false };
          } else if (item.fieldType === 24) {
            console.log(923, item.fieldExt);
            const fieldExt = tools.isJSON(item.fieldExt) ? JSON.parse(item.fieldExt) : item.fieldExt;
            if (fieldExt.type == 6 || fieldExt.type == 16) {
              //汇总金额，金额
              tempstr = { field: item.fieldKey, value: m?.[1]?.val === 0 ? 0 : m?.[1]?.selectVal != 'null' && m?.[1]?.selectVal != 'not_null' ? Number(tools.setPrice(m?.[1]?.val)) : null, operation: m?.[1]?.selectVal, isGroup: false };
            } else if (fieldExt.type == 8) {
              //日期
              const paramsDate = { beginDate: dayjs(m[1][0]).format('YYYY-MM-DD'), endDate: dayjs(m[1][1]).format('YYYY-MM-DD') };
              tempstr = { field: item.fieldKey, value: paramsDate, operation: 'between', isGroup: false };
            } else if (fieldExt.type == 23) {
              //百分比
              tempstr = { field: item.fieldKey, value: m?.[1]?.val === 0 ? 0 : m?.[1]?.selectVal != 'null' && m?.[1]?.selectVal != 'not_null' ? Number(divideAndRound(m?.[1]?.val)) : null, operation: m?.[1]?.selectVal, isGroup: false };
            } else {
              //数字
              tempstr = { field: item.fieldKey, value: m?.[1]?.val === 0 ? 0 : m?.[1]?.selectVal != 'null' && m?.[1]?.selectVal != 'not_null' ? Number(m?.[1]?.val) : null, operation: m?.[1]?.selectVal, isGroup: false };
            }
          } else {
            let operation = 'equals';
            if (checkboxFieldList.indexOf(item.fieldKey) !== -1) {
              if (data.fieldTypeList.indexOf(item.fieldType) != -1) {
                operation = 'in';
              }
              if (item.fieldKey == 'qccId') {
                //企查查id特殊处理
                if (m[1]?.length != 2) {
                  //选择全部不做处理
                  operation = 'null';
                  if (m[1].join(',') == '1') {
                    operation = 'not_null';
                  }
                  tempstr = { field: item.fieldKey, value: m[1]?.length == 2 ? '' : m[1].join(','), operation: operation, isGroup: false };
                }
              } else {
                tempstr = { field: item.fieldKey, value: m[1]?.length == 2 ? '' : m[1].join(','), operation: operation, isGroup: false };
              }
            } else {
              if (data.fieldTypeList.indexOf(item.fieldType) != -1) {
                operation = 'in';
              }
              tempstr = { field: item.fieldKey, value: m[1] instanceof Array ? m[1].join(',') : m[1], operation: operation, isGroup: false };
            }
          }
          userInfo.orgId == huaYingOrdId && entity == 2 ? filterParams.conditions[0]['children'][1]['children'].push(tempstr) : filterParams.conditions[0]['children'].push(tempstr);
        }
      });
    });
    if (entity == 101) {
      console.log(1496, data.filterSearchList, v);
      filterParams.conditions[0]['children'].push({
        field: 'cluePoolId',
        isGroup: false,
        operation: 'equals',
        value: v.limits || (data.filterSearchList.leadPoolSelect?.length && data.filterSearchList.leadPoolSelect[0]?.value) || -1
      });
    }

    // console.log('筛选查询最终参数11111', filterParams);
    data.filterSearchParams = filterParams;
    return filterParams;
  };
  //判断字段是否必填及是否显示 要上传表单数据 entity
  const fieldConditionsJoker = async (customForm, entity) => {
    if (customForm && entity) {
      const params = {
        entity: entity,
        data: {},
        jokers: []
      };
      customForm.forEach((item) => {
        if (item?.modules) {
          item?.modules.forEach((list) => {
            if (list.type == 20) {
              //字段
              let fieldValue = list?.fieldValue;
              const fieldType = list.setting.fieldType == 21 ? list?.setting?.business?.fieldType : list.setting.fieldType;

              const fieldExt = list.setting.fieldType == 21 ? list?.setting?.business?.fieldExt : list.setting.fieldExt;
              if (fieldType === 3 || fieldType === 5) {
                fieldValue = fieldValue && Array.isArray(fieldValue) ? fieldValue?.join(',') : null;
              } else if (fieldType === 9) {
                const hasValue = tools.hasDateRange(fieldValue);
                const v = { beginDate: fieldValue?.[0], endDate: fieldValue?.[1] };
                fieldValue = hasValue ? JSON.stringify(v) : '';
              } else if (fieldType === 10) {
                fieldValue = list?.fieldValue && Array.isArray(list?.fieldValue) ? list?.fieldValue?.join('/') : null;
              } else if (fieldType === 6) {
                //人员传递参数是字符串ID以逗号分割
                const userIds = list.setting?.fv?.userList?.map((u) => u.id)?.join(',');
                fieldValue = userIds || '';
              } else if (fieldType === 12) {
                //查找关联
                fieldValue = list?.fieldValue?.label || list?.customValue?.label || list?.fieldValueName || list?.fieldValue || '';
              } else if (fieldType === 16) {
                fieldValue = fieldValue ? String(tools.setPrice(fieldValue)) : null;
              } else if (fieldType === 18) {
                // fieldValue = fieldValue ? JSON.stringify(fieldValue) : null;
                // 过滤掉数组中的 null 值后再序列化，若结果为空则设为 null
                fieldValue = fieldValue && Array.isArray(fieldValue) ? JSON.stringify(fieldValue.filter((item) => item != null)) : null;
              } else if (fieldType === 22) {
                const departList = list.setting?.fv?.departList?.map((u) => u.id)?.join(',');
                fieldValue = departList || '';
              } else if (fieldType === 23) {
                fieldValue = fieldValue ? tools.setPercentage(fieldValue, JSON.parse(fieldExt).numberFormat) : null;
              } else if (fieldType === 24) {
                //计算类型
                if (fieldExt && tools.isJSON(fieldExt)) {
                  const getFieldExt = JSON.parse(fieldExt);
                  if (getFieldExt?.type == 6 || getFieldExt?.type == 16) {
                    //6：汇总金额 16：金额
                    fieldValue = fieldValue ? tools.setPrice(fieldValue, getFieldExt?.dataType) : '';
                  } else if (getFieldExt?.type == 23) {
                    //百分比
                    fieldValue = fieldValue ? tools.setPercentage(fieldValue, getFieldExt?.dataType) : '';
                  } else if (getFieldExt?.type == 5 || getFieldExt?.type == 7) {
                    // 数字
                    fieldValue = fieldValue == null ? fieldValue : Number(fieldValue).toFixed(getFieldExt?.dataType) ?? '';
                  }
                }
              } else if (fieldType === 25) {
                fieldValue = list?.customValue?.[0]?.label ? list?.customValue?.map((v) => v.label)?.join(',') : list?.fieldValueName?.length > 0 ? list?.fieldValueName?.join(',') : null;
              } else {
                fieldValue = list?.fieldValue;
              }
              params.data[list.value] = fieldValue;

              if (list.display == 2) {
                //满足条件显示
                params.jokers.push({ type: 2, field: list.value, conditions: list.displayConditions });
              }
              if (list.isRequired == 2) {
                //满足条件必填
                params.jokers.push({ type: 1, field: list.value, conditions: list.requiredConditions });
              }
            }
            if (list.type == 30 || list.type == 35) {
              //表格，子表单
              if (list.display == 2) {
                //满足条件显示
                params.jokers.push({ type: 2, field: list.id, conditions: list.displayConditions });
              }
              if (list.isRequired == 2) {
                //满足条件必填
                params.jokers.push({ type: 1, field: list.id, conditions: list.requiredConditions });
              }
            }
            if (list.type == 35) {
              //子表单--子字段
              list?.modules?.forEach((el) => {
                //子字段满足条件必填
                if (el.isRequired == 2) {
                  params.jokers.push({ type: 1, field: list.value + '.' + el.value, conditions: el.requiredConditions });
                }
              });
            }
          });
        }
      });
      if (!params?.jokers?.length) return;
      try {
        const json = await layoutService.getLayoutfieldjoker(params);
        data.fieldsJokerList = json?.result || [];

        return data;
      } catch (e) {
        return [];
      }
    } else {
      data.fieldsJokerList = {};
      return data;
    }
  };

  //获取引用字段的值
  const getReferenceFieldValue = async (params) => {
    if (params) {
      return new Promise((resolve, reject) => {
        params['apiIndex'] = Math.random();
        publicService
          .getReferenceField(params)
          .then((res) => {
            if (res.error && res.error?.msg) {
              Message.error(i18n.global.t('系统开小差了，请过后重试'));
            }
            resolve(res);
          })
          .catch((err) => {
            Message.error(i18n.global.t('系统开小差了，请过后重试'));
            reject(err);
          });
      });
    } else {
      return [];
    }
  };

  //给引用字段赋值
  const setReferenceFieldValue = async (formData, modulesItem) => {
    formData?.forEach(async (list) => {
      if (list?.modules) {
        list?.modules.forEach(async (item) => {
          if (item.type == 20) {
            if (item.setting.fieldType == 21) {
              //引用字段
              const getFieldExt = JSON.parse(item?.setting?.fieldExt);
              if (modulesItem.setting.fieldKey == getFieldExt.findAssociateField) {
                if (modulesItem.fieldValue) {
                  try {
                    await getReferenceFieldValue({ entity: Number(modulesItem?.setting?.fieldExt), associateId: modulesItem.fieldValue, referenceField: getFieldExt.referenceField, apiIndex: item.id })
                      .then((res) => {
                        item.setting.business = res?.result?.business || '';
                        item.fieldValue = res?.result?.value ?? '';

                        // if (item?.setting?.business?.fieldType === 3 || item?.setting?.business?.fieldType === 5) {
                        //   //多选按钮，下拉多选
                        //   item.fieldValue = res?.result?.value ? res?.result?.value?.split(',') : '';
                        // } else if (item?.setting?.business?.fieldType === 6) {
                        //   //人员
                        //   const _userList = [];
                        //   const _userNameList = [];
                        //   if (res?.result?.value && res?.result?.value?.length) {
                        //     res?.result?.value?.map((rrv) => {
                        //       _userList.push({
                        //         userName: rrv?.userName,
                        //         id: rrv?.userId,
                        //         avatarOrigin: rrv?.avatar
                        //       });
                        //       _userNameList.push(rrv?.userName);
                        //     });
                        //   }
                        //   item.setting.business.fv = {
                        //     departList: [],
                        //     userList: _userList
                        //   };
                        //   item.fieldValue = _userNameList;
                        // } else if (item?.setting?.business?.fieldType === 7) {
                        //   //数字
                        //   item.fieldValue = res?.result?.value == null ? res?.result?.value : Number(res?.result?.value);
                        // } else if (item?.setting?.business?.fieldType === 9) {
                        //   //日期范围
                        //   item.fieldValue = res?.result?.value ? Object.values(JSON.parse(res?.result?.value)) : [];
                        // } else if (item?.setting?.business?.fieldType === 10) {
                        //   //级联选择
                        //   item.fieldValue = res?.result?.value ? res?.result?.value?.split('/') : '';
                        // } else if (item?.setting?.business?.fieldType === 12) {
                        //   //查找关联（单选）
                        //   //   item.fieldValue = res?.result?.label ? [res?.result?.label] : [];
                        //   if (res?.result?.value?.label && res?.result?.value?.value) {
                        //     item.fieldValue = res?.result?.value?.value;
                        //     //兼容查找关联单选反显
                        //     item['fieldValueName'] = res?.result?.value?.label;
                        //   } else {
                        //     item.fieldValue = res?.result?.value?.value;
                        //     item['fieldValueName'] = res?.result?.value?.value;
                        //   }
                        // } else if (item?.setting?.business?.fieldType == 16) {
                        //   //金额
                        //   if (item?.setting?.business?.fieldExt) {
                        //     item.fieldValue = res?.result?.value ? tools.getPrice(res?.result?.value, item?.setting?.business?.fieldExt || 2) : '';
                        //   } else {
                        //     item.fieldValue = res?.result?.value ? tools.getPrice(res?.result?.value) : '';
                        //   }
                        // } else if (item?.setting?.business?.fieldType == 18) {
                        //   //附件
                        //   // item.fieldValue = res?.result?.value ? JSON.parse(res?.result?.value) : '';
                        //   item.fieldValue = tools.isJSON(res?.result?.value) ? JSON.parse(res?.result?.value)?.filter((i) => i != null) : '';
                        // } else if (item?.setting?.business?.fieldType == 22) {
                        //   //部门
                        //   item.setting.business.fv = {
                        //     departList:
                        //       res?.result?.value && Array.isArray(res?.result?.value)
                        //         ? res?.result?.value?.map((u) => {
                        //             return {
                        //               departmentName: u.name,
                        //               id: u.id
                        //             };
                        //           })
                        //         : [],
                        //     userList: []
                        //   };
                        //   item.fieldValue = res?.result?.value && Array.isArray(res?.result?.value) ? res?.result?.value?.map((u) => u.name) : [];
                        // } else if (item?.setting?.business?.fieldType == 23) {
                        //   //百分比
                        //   item.fieldValue = res?.result?.value ? tools.getPercentage(res?.result?.value, JSON.parse(item?.setting?.business?.fieldExt)?.numberFormat ?? 2) : '';
                        // } else if (item?.setting?.business?.fieldType == 24) {
                        //   //计算类型
                        //   if (tools.isJSON(item?.setting?.business?.fieldExt)) {
                        //     const fieldExt = JSON.parse(item?.setting?.business?.fieldExt);
                        //     if (fieldExt?.type === 6 || fieldExt?.type === 16) {
                        //       // 6:汇总金额类型  16：金额
                        //       item.fieldValue = res?.result?.value ? tools.getPrice(res?.result?.value, fieldExt?.dataType ?? 2) : '';
                        //     } else if (fieldExt?.type === 23) {
                        //       //百分比
                        //       item.fieldValue = res?.result?.value ? tools.getPercentage(res?.result?.value, fieldExt?.dataType ?? 2) : '';
                        //     } else if (fieldExt?.type === 5 || fieldExt?.type === 7) {
                        //       //数字
                        //       item.fieldValue = !isNaN(parseFloat(res?.result?.value)) ? Number(parseFloat(res?.result?.value).toFixed(fieldExt?.dataType ?? 2)) : '';
                        //     } else {
                        //       item.fieldValue = res?.result?.value ?? '';
                        //     }
                        //   }
                        // } else if (item?.setting?.business?.fieldType === 25) {
                        //   //查找关联（多选）
                        //   item['fieldValueName'] = res.result?.value?.length ? res.result?.value?.map((v) => v.label) : [];
                        // } else {
                        //   item.fieldValue = res?.result?.value ?? '';
                        // }
                      })
                      .finally(() => {
                        console.log('finally');
                      });
                  } catch (error) {
                    console.error('Error occurred:', error);
                    // 终止循环
                    return;
                  }
                } else {
                  item.setting.business = '';
                  item.fieldValue = '';
                }
              }
            }
          }
        });
      }
    });

    console.log('引用字段最终值', formData);
    data.referenceFieldValue = formData;
    return data;
  };

  // 布局--线索转化
  const clueConversionLayoutInit = async (params) => {
    if (params) {
      try {
        const json = await layoutService.clueConversionLayoutInit(params);
        data.conversionLayoutList = json?.result && json?.result[0]?.modules ? setFieldValue(json?.result, 40, 'conversion') : [];
        return data;
      } catch (e) {
        console.log('若返回空数组，表示数据格式有问题，请关闭try/catch调试');
        return [];
      }
    } else {
      return [];
    }
  };
  // 线索转化客户提交时数据处理
  const clueConversionLayoutSave = (conversionList) => {
    data.conversionData = {
      allFieldsObj: {}, //所有字段对象
      tableList: [] //表格列表
    };
    if (conversionList && conversionList?.length > 0) {
      conversionList.forEach((item) => {
        if (item?.modules) {
          item?.modules.forEach((list) => {
            if (list.type == 20 && list.setting.fieldType != 21 && list.setting.fieldType != 24) {
              //字段
              let fieldValue = list?.fieldValue;
              if (list.setting.fieldType === 3 || list.setting.fieldType === 5) {
                fieldValue = fieldValue?.join(',') || null;
              } else if (list.setting.fieldType === 9) {
                const hasValue = tools.hasDateRange(fieldValue);
                const v = { beginDate: fieldValue?.[0], endDate: fieldValue?.[1] };
                fieldValue = hasValue ? JSON.stringify(v) : '';
              } else if (list.setting.fieldType === 10) {
                fieldValue = fieldValue ? fieldValue?.join('/') : '';
              } else if (list.setting.fieldType === 6) {
                //人员传递参数是字符串ID以逗号分割
                const userIds = list.setting?.fv?.userList?.map((u) => u.id)?.join(',');
                fieldValue = userIds || '';
              } else if (list.setting.fieldType === 16) {
                fieldValue = tools.setPrice(fieldValue) ?? '';
              } else if (list.setting.fieldType === 18) {
                const validAttachments = Array.isArray(fieldValue) ? fieldValue.filter((item) => item != null) : [];
                fieldValue = validAttachments?.length > 0 ? JSON.stringify(validAttachments) : '';
              } else if (list.setting.fieldType === 22) {
                //部门传递参数是字符串ID以逗号分割
                const departIds = list.setting?.fv?.departList?.map((u) => u.id)?.join(',');
                fieldValue = departIds || '';
              } else if (list.setting.fieldType === 23) {
                fieldValue = fieldValue ? tools.setPercentage(fieldValue, JSON.parse(list.setting.fieldExt).numberFormat) : null;
              }

              data.conversionData.allFieldsObj[list.value] = fieldValue;
            }
          });
        }
      });
    }
  };
  //获取部门及负责人信息
  const getDept = async (params) => {
    if (params) {
      try {
        const json = await publicService.getDepartment(params);
        data.departmentList = json?.result || [];
        return data;
      } catch (e) {
        return [];
      }
    } else {
      return [];
    }
  };

  //获取看板分组字段 过滤单选、下拉单选和人员类型 并且提出系统字段的锁定和流程状态
  const getDashBoardGroupFields = (fields) => {
    return fields?.filter((field) => {
      return !['processStatus', 'locked']?.includes(field?.fieldKey) && [2, 4, 6].includes(field?.fieldType);
    });
  };

  return {
    getAssociationFields,
    getViewFields,
    fieldConditionsJoker,
    rules,
    saveFormData,
    getFieldLabel,
    getFieldValue,
    getFilterParams,
    fitlterFields,
    fitlterLayoutFields,
    getLayoutFieldsObject,
    getAddLayoutConfig,
    getEditLayoutConfig,
    getLayoutDetailConfigArea,
    setLayoutLoadingStatus,
    getLayoutAllFields,
    clueConversionLayoutInit,
    clueConversionLayoutSave,
    setReferenceFieldValue,
    getDept,
    getLeadPoolSelect,
    setEditForm,
    setEditFormTable,
    getComputeing,
    showFieldsLabel,
    setFieldValue,
    getFormFieldValue,
    setRecordData,
    getDashBoardGroupFields,
    ...toRefs(data)
  };
}
